const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-lz.a.run.app';
const configsLive = 'https://beta-sb-app-configs-djgqciaueq-ew.a.run.app';
export const url = () => {
  return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
};

export const getStatus = async (id, token, gridId) => {
  let apiUrl = url() + '/live?cid=' + id + '&token=' + token;
  if (gridId) {
    apiUrl += '&grid_id=' + gridId;
  }
  const res = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());
  return res;
};

export const getGridList = async (id, token) => {
  const res = await fetch(url() + '/configs/homepage/list/' + id + '?token=' + token);
  const json = await res.json();
  return json;
};
